/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { axios, changeDisplayedName, leaveType } from "../../../common";
import Form, {
  Item,
  RequiredRule,
  Label,
  StringLengthRule,
} from "devextreme-react/form";
import { DateBox, SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import "./style.scss";
function FormApprovalSetting({
  user,
  formData,
  symbol,
  employee,
  setEmployeeOid,
  employeeOid,
}) {
  const [isSelectHour, setIsSelectHour] = useState(false);
  const [valueLeaveType, setValueLeaveType] = useState("");
  const [valueSymbol, setValueSymbol] = useState("");
  const [leaveRegistration, setLeaveRegistration] = useState({});

  useEffect(() => {
    const getLeaveRegistration = async () => {
      const { data } = await axios.get("LeaveRegistration", {
        params: {
          $top: 2,
          $expand: "Employee($expand=Department,Position)",
          $filter: `Employee/Oid eq ${user.EmployeeOid} eq true`,
        },
      });
      setLeaveRegistration(data.value[0]);
      return data.value;
    };
    getLeaveRegistration();
  }, []);
  function gridBoxDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }
  useEffect(() => {
    const setLeaveType = () => {
      const { LeaveType, Symbol } = formData.current;
      switch (LeaveType) {
        case "FullDay":
          setValueLeaveType(0);
          break;
        case "Before":
          setValueLeaveType(1);
          break;
        case "After":
          setValueLeaveType(2);
          break;
        case "Hour":
          setValueLeaveType(3);
          break;

        default:
          break;
      }
      setValueSymbol(Symbol?.Oid);
    };
    setLeaveType();
  }, [formData.current]);

  const symbolEditorOptions = {
    items: symbol,
    value: valueSymbol,
    searchEnabled: true,
    placeholder: formatMessage("PlaceholderSymbol"),
    displayExpr: "SymbolName",
    valueExpr: "Oid",
    searchExpr: "SymbolName",
    searchMode: "contains",
    showClearButton: true,
    onValueChanged: (e) => {
      formData.current.SymbolOid = e.value;
    },
  };
  const leaveTypeEditorOptions = {
    items: leaveType,
    value: valueLeaveType,
    searchEnabled: true,
    placeholder: formatMessage("PlaceholderLeaveType"),
    valueExpr: "id",
    displayExpr: changeDisplayedName(),
    showClearButton: true,
    onValueChanged: (e) => {
      if (e.value === 3) {
        setValueLeaveType(e.value);
        formData.current.LeaveType = `${e.value}`;
        setIsSelectHour(true);
      } else {
        setValueLeaveType(e.value);
        formData.current.LeaveType = `${e.value}`;
        setIsSelectHour(false);
      }
    },
  };

  return (
    <div className="d-flex form-leave-registration">
      <Form
        colCount={1}
        id="form-leave"
        formData={formData.current}
        className={"form-editor"}
      >
        <Item dataField="Employee">
          <SelectBox
            valueExpr="Oid"
            dataSource={employee}
            value={employeeOid}
            displayExpr={gridBoxDisplayExpr}
            itemRender={gridBoxDisplayExpr}
            onValueChanged={(e) => {
              setEmployeeOid(e.value);
            }}
            searchEnabled={true}
          />
          <Label text={formatMessage("Employee")} />
          <RequiredRule message={formatMessage("ValidateEmployee")} />
        </Item>
        <Item
          dataField="Symbol"
          editorType="dxSelectBox"
          editorOptions={symbolEditorOptions}
        >
          <Label text={formatMessage("Symbol")} />
          <RequiredRule message={formatMessage("ValidateSymbol")} />
        </Item>
        <Item
          dataField="LeaveType"
          editorType="dxSelectBox"
          editorOptions={leaveTypeEditorOptions}
        >
          <Label text={formatMessage("LeaveType")} />
          <RequiredRule message={formatMessage("ValidateLeaveType")} />
        </Item>
        <Item dataField="FromDate" editorType="dxDateBox">
          <Label text={formatMessage("FromDate")} />
          <RequiredRule message={formatMessage("ValidateFromDate")} />
        </Item>
        <Item dataField="ToDate" editorType="dxDateBox">
          <Label text={formatMessage("ToDate")} />
          <RequiredRule message={formatMessage("ValidateToDate")} />
        </Item>
        {isSelectHour && (
          <Item dataField="StartTime">
            <DateBox
              onValueChanged={(e) => {
                formData.current.StartTime = e.value;
              }}
              dataField="StartTime"
              type="time"
            >
              <Label text={formatMessage("StartTime")} />
              <RequiredRule message={formatMessage("ValidateStartTime")} />
            </DateBox>
          </Item>
        )}
        {isSelectHour && (
          <Item dataField="EndTime">
            <DateBox
              onValueChanged={(e) => {
                formData.current.EndTime = e.value;
              }}
              dataField="EndTime"
              type="time"
            >
              <Label text={formatMessage("EndTime")} />
              <RequiredRule message={formatMessage("ValidateEndTime")} />
            </DateBox>
          </Item>
        )}
        <Item dataField="Description" editorType="dxTextArea">
          <StringLengthRule max="250" />
          <Label text={formatMessage("Description")} />
        </Item>
      </Form>
      <div className="form-text">
        <table className="data-readonly">
          <tbody>
            <tr>
              <td>
                <div className="fw-bold text-uppercase">
                  {formatMessage("LeaveSummary")}
                </div>
              </td>
              <td></td>
            </tr>
            {leaveRegistration && (
              <div>
                <tr>
                  <td>{formatMessage("LeaveTotal")}:</td>
                  <td>
                    {leaveRegistration.LeaveTotal} {formatMessage("Day")}
                  </td>
                </tr>
                <tr>
                  <td>{formatMessage("LeaveUsed")}:</td>
                  <td>
                    {leaveRegistration.LeaveUsed} {formatMessage("Day")}
                  </td>
                </tr>
                <tr>
                  <td>{formatMessage("LeaveRemain")}:</td>
                  <td>
                    {leaveRegistration.LeaveRemain} {formatMessage("Day")}
                  </td>
                </tr>
              </div>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default React.memo(FormApprovalSetting);